import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { Component, Inject, Input } from 'angular-ts-decorators';
import { ICompareCheckboxService } from 'src/Foundation/Design/platform';

import template from './compare-basket-product.component.html';

@Component({
  selector: 'compareBasketProduct',
  template,
})
export class CompareBasketProductComponent {
  public static $inject: ReadonlyArray<string> = ['compareCheckboxService'];

  @Input() public product?: IFamily;

  constructor(@Inject('compareCheckboxService') private compareCheckboxService: ICompareCheckboxService) {
  }

  public removeProduct(): void {
    return this.compareCheckboxService.toggle(this.product.familyId);
  }
}
